import { api } from "../../axios";

export const actions = {

    //IndicatorItemGroup
    GetIndicatorItemGroup(){
        return api.get(`IndicatorItemGroup/All`);
    },
    GetSingleIndicatorItemGroup(context, data){
        return api.get(`IndicatorItemGroup/${data}`);
    },
    UpdateIndicatorItemGroup(context, data){
        return api.put(`IndicatorItemGroup/${data.id}`, data);
    },
    DeleteIndicatorItemGroup(context, data){
        return api.delete(`IndicatorItemGroup/${data}`);
    },
    CreateIndicatorItemGroup(context, data){
        return api.post(`IndicatorItemGroup/Add`, data);
    },

}